// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PWifiOutlinedSvg from "@fishx/icons-svg/es/asn/PWifiOutlined";
import FishxIcon from '../components/FishxIcon';

var PWifiOutlined = function PWifiOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PWifiOutlinedSvg
  }));
};

PWifiOutlined.displayName = 'PWifiOutlined';
export default React.forwardRef(PWifiOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PWifiOutlined.js
// module id = 3731
// module chunks = 0